/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ErrorResp,
  GetTransactionAttributesV4Params,
  GetTransactionsV2Params,
  GetTransactionsV3Params,
  GetTransactionsV4Params,
  Transaction2,
  Transactions,
  Transactions1,
  Transactions2,
  TransactionsAttributes,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get Transactions
 */
export const getTransactionsV2 = (
  branch: string,
  from: number,
  to: number,
  params?: GetTransactionsV2Params,
  signal?: AbortSignal,
) => {
  return customInstance<Transactions>({
    url: `/BboMockTransactionApiService/transactionviewer/v2/branch/${branch}/from/${from}/to/${to}/transactions`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetTransactionsV2QueryKey = (
  branch: string,
  from: number,
  to: number,
  params?: GetTransactionsV2Params,
) => {
  return [
    `/BboMockTransactionApiService/transactionviewer/v2/branch/${branch}/from/${from}/to/${to}/transactions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTransactionsV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getTransactionsV2>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  from: number,
  to: number,
  params?: GetTransactionsV2Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionsV2>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransactionsV2QueryKey(branch, from, to, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactionsV2>>> = ({ signal }) =>
    getTransactionsV2(branch, from, to, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(branch && from && to),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTransactionsV2>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetTransactionsV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransactionsV2>>
>;
export type GetTransactionsV2QueryError = ErrorType<ErrorResp>;

/**
 * @summary Get Transactions
 */
export const useGetTransactionsV2 = <
  TData = Awaited<ReturnType<typeof getTransactionsV2>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  from: number,
  to: number,
  params?: GetTransactionsV2Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionsV2>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTransactionsV2QueryOptions(branch, from, to, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Transactions
 */
export const getTransactionsV3 = (
  branch: string,
  from: number,
  to: number,
  params?: GetTransactionsV3Params,
  signal?: AbortSignal,
) => {
  return customInstance<Transactions1>({
    url: `/BboMockTransactionApiService/transactionviewer/v3/branch/${branch}/from/${from}/to/${to}/transactions`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetTransactionsV3QueryKey = (
  branch: string,
  from: number,
  to: number,
  params?: GetTransactionsV3Params,
) => {
  return [
    `/BboMockTransactionApiService/transactionviewer/v3/branch/${branch}/from/${from}/to/${to}/transactions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTransactionsV3QueryOptions = <
  TData = Awaited<ReturnType<typeof getTransactionsV3>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  from: number,
  to: number,
  params?: GetTransactionsV3Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionsV3>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransactionsV3QueryKey(branch, from, to, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactionsV3>>> = ({ signal }) =>
    getTransactionsV3(branch, from, to, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(branch && from && to),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTransactionsV3>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetTransactionsV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransactionsV3>>
>;
export type GetTransactionsV3QueryError = ErrorType<ErrorResp>;

/**
 * @summary Get Transactions
 */
export const useGetTransactionsV3 = <
  TData = Awaited<ReturnType<typeof getTransactionsV3>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  from: number,
  to: number,
  params?: GetTransactionsV3Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionsV3>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTransactionsV3QueryOptions(branch, from, to, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Transactions
 */
export const getTransactionsV4 = (
  branch: string,
  params: GetTransactionsV4Params,
  signal?: AbortSignal,
) => {
  return customInstance<Transactions2>({
    url: `/BboMockTransactionApiService/transactionviewer/v4/branch/${branch}/transactions`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetTransactionsV4QueryKey = (branch: string, params: GetTransactionsV4Params) => {
  return [
    `/BboMockTransactionApiService/transactionviewer/v4/branch/${branch}/transactions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTransactionsV4QueryOptions = <
  TData = Awaited<ReturnType<typeof getTransactionsV4>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  params: GetTransactionsV4Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionsV4>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransactionsV4QueryKey(branch, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactionsV4>>> = ({ signal }) =>
    getTransactionsV4(branch, params, signal);

  return { queryKey, queryFn, enabled: !!branch, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransactionsV4>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTransactionsV4QueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransactionsV4>>
>;
export type GetTransactionsV4QueryError = ErrorType<ErrorResp>;

/**
 * @summary Get Transactions
 */
export const useGetTransactionsV4 = <
  TData = Awaited<ReturnType<typeof getTransactionsV4>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  params: GetTransactionsV4Params,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionsV4>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTransactionsV4QueryOptions(branch, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Transaction Atributes
 */
export const getTransactionAttributesV4 = (
  branch: string,
  params: GetTransactionAttributesV4Params,
  signal?: AbortSignal,
) => {
  return customInstance<TransactionsAttributes>({
    url: `/BboMockTransactionApiService/transactionviewer/v4/branch/${branch}/uniqueTransactionsAttributes`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetTransactionAttributesV4QueryKey = (
  branch: string,
  params: GetTransactionAttributesV4Params,
) => {
  return [
    `/BboMockTransactionApiService/transactionviewer/v4/branch/${branch}/uniqueTransactionsAttributes`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTransactionAttributesV4QueryOptions = <
  TData = Awaited<ReturnType<typeof getTransactionAttributesV4>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  params: GetTransactionAttributesV4Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTransactionAttributesV4>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransactionAttributesV4QueryKey(branch, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactionAttributesV4>>> = ({
    signal,
  }) => getTransactionAttributesV4(branch, params, signal);

  return { queryKey, queryFn, enabled: !!branch, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransactionAttributesV4>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTransactionAttributesV4QueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransactionAttributesV4>>
>;
export type GetTransactionAttributesV4QueryError = ErrorType<ErrorResp>;

/**
 * @summary Get Transaction Atributes
 */
export const useGetTransactionAttributesV4 = <
  TData = Awaited<ReturnType<typeof getTransactionAttributesV4>>,
  TError = ErrorType<ErrorResp>,
>(
  branch: string,
  params: GetTransactionAttributesV4Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTransactionAttributesV4>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTransactionAttributesV4QueryOptions(branch, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Basket Transactions
 */
export const getBasketTransactions = (basketID: string, signal?: AbortSignal) => {
  return customInstance<Transaction2[]>({
    url: `/BboMockTransactionApiService/transactionviewer/v4/basketID/${basketID}/transactions`,
    method: 'get',
    signal,
  });
};

export const getGetBasketTransactionsQueryKey = (basketID: string) => {
  return [
    `/BboMockTransactionApiService/transactionviewer/v4/basketID/${basketID}/transactions`,
  ] as const;
};

export const getGetBasketTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBasketTransactions>>,
  TError = ErrorType<ErrorResp>,
>(
  basketID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBasketTransactions>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBasketTransactionsQueryKey(basketID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBasketTransactions>>> = ({ signal }) =>
    getBasketTransactions(basketID, signal);

  return { queryKey, queryFn, enabled: !!basketID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBasketTransactions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBasketTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBasketTransactions>>
>;
export type GetBasketTransactionsQueryError = ErrorType<ErrorResp>;

/**
 * @summary Get Basket Transactions
 */
export const useGetBasketTransactions = <
  TData = Awaited<ReturnType<typeof getBasketTransactions>>,
  TError = ErrorType<ErrorResp>,
>(
  basketID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBasketTransactions>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBasketTransactionsQueryOptions(basketID, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
